import toast from 'react-hot-toast'

export const toastSuccess = (meg) => {
   toast.success(meg)
}
export const toastError = (meg) => {
   toast.error(meg)
}
